import classNames from 'classnames'
import React from 'react'

export interface MySvgIconProps {
  className?:string
  focusable?: boolean
  title?: string
  children?: any
  width?: string
  height?: string
  viewBox?: string
  version?: string
}

export const MySvgIcon:React.FC<MySvgIconProps> = ({
  children,
  title,
  className = '',
  focusable = false, // focusable defaults to true, so we need to explicitly declare it false
  ...props
}) => {
  const wrapperClassNames = classNames(
    'my-c-my-svg-icon',
    className
  )
  return (
    <span className={wrapperClassNames}>
      <svg
        className='my-c-my-svg-icon__svg'
        role={title ? 'img' : undefined}
        aria-hidden={!title}
        aria-label={title}
        xmlns='http://www.w3.org/2000/svg'
        focusable={focusable}
        {...props}
      >
        {children}
      </svg>
    </span>
  )
}
